import { Injectable } from '@angular/core';
import { ConfirmComponent } from '../../modules/auth/pages/confirm/confirm.component';
import { AlertComponent } from '../../modules/auth/pages/alert/alert.component';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Injectable({ providedIn: 'root' })
export class DialogService {

  constructor(
    private modal: BsModalService,
  ) {
  }

  public openConfirm(message: string, size = 'modal-lg', okBtn = 'はい', cancelBtn = 'いいえ') {

    const config = {
      backdrop: 'static',
      class: size,
      initialState: {
        message: message,
        okBtn: okBtn,
        cancelBtn: cancelBtn
      }
    } as ModalOptions;

    const modal = this.modal.show(ConfirmComponent, config);
    return modal;
  }

  public openAlert(message: string, size = 'modal-lg', okBtn = 'OK') {

    const config = {
      class: size,
      initialState: {
        message: message,
        okBtn: okBtn,
      }
    } as ModalOptions;

    const modal = this.modal.show(AlertComponent, config);
    return modal;
  }
}
